import {subHours} from 'date-fns';
import {Operators} from 'shared/migration-components/filter-list/types';
import dateFnsService from 'shared/services/date-fns-service';

const now = new Date();

export default [
  {
    operator: Operators.GreaterThanEqual,
    value: {
      date: dateFnsService.apiDateFormat(now),
      time: dateFnsService.format(subHours(new Date(), 3), 'HH:mm:ss'),
    },
  },
  {
    operator: Operators.LessThanEqual,
    value: {date: dateFnsService.apiDateFormat(now), time: '23:59:59'},
  },
];
